import { nanoid } from 'nanoid';
import xhrCache from './cache';

export default async (url, { id = nanoid(), data, headers = {}, method = 'PUT', onProgress }) => {
  if (xhrCache[id]) throw new Error('`id` is already in use');

  let xhr;

  return new Promise((resolve, reject) => {
    xhr = new XMLHttpRequest();
    xhrCache[id] = xhr;

    xhr.addEventListener('readystatechange', () => {
      if (xhr.readyState === XMLHttpRequest.DONE) {
        const { status } = xhr;
        if (status === 200 || status === 204) {
          resolve(xhr);
        } else {
          reject(xhr.statusText);
        }
      }
    });
    xhr.upload.addEventListener('progress', onProgress);

    xhr.open(method, url);
    Object.entries(headers).forEach(([header, value]) => xhr.setRequestHeader(header, value));
    xhr.send(data);
  }).finally(() => {
    delete xhrCache[id];
  });
};
